import React, { useContext, useMemo, useState } from 'react';
import { CourseMenuList } from '../layout/leftNav/menus/iconList/CourseMenuList';

export enum ViewStates {
    None,
    UnitsView,
    SettingView,
    BuilderView,
    QuizQuestionView,
}

type LeftsideNavDispatch = {
    setViewState: (state: ViewStates) => void;
    removeViewState: () => void;
};

const LeftsideContext = React.createContext<ViewStates | null>(null);
const LeftsideDispatch = React.createContext<LeftsideNavDispatch | null>(null);

/**
 * Custom routing and components for the Left Side Nav.
 * Sub navigatiing routes.
 * 2 Variations -
 * 1. Courses and Course / View ares
 * 2. Account Settings / Profile / Etc..
 *
 * @param param0
 * @returns
 */
export function LeftsideContextProvider({ children }: { children: React.ReactNode }) {
    const [state, setState] = useState<ViewStates>(ViewStates.UnitsView);

    const dispatch = useMemo(
        () => ({
            setViewState: (view: ViewStates) => {
                setState(view);
            },
            removeViewState: () => {
                setState(ViewStates.None);
            },
        }),
        [setState],
    );

    return (
        <LeftsideContext.Provider value={state}>
            <LeftsideDispatch.Provider value={dispatch}>{children}</LeftsideDispatch.Provider>
        </LeftsideContext.Provider>
    );
}

export function useLeftsideState() {
    const context = useContext(LeftsideContext);
    if (context === null) {
        throw new Error('<LeftsideNavContextType /> expected to present in the parent tree');
    }
    return context;
}

export function useLeftsideDispatch() {
    const context = useContext(LeftsideDispatch);
    if (context === null) {
        throw new Error('<LeftsideNavContextType /> expected to present in the parent tree');
    }
    return context;
}
